import styled from 'styled-components';

import SelectFilter from '@components/SelectFilter';

export const PostSelectFilter = styled(SelectFilter)`
  min-width: 150px;
`;
